var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23447 5.83456C4.3845 5.68459 4.58794 5.60033 4.80007 5.60033C5.0122 5.60033 5.21565 5.68459 5.36567 5.83456L8.00007 8.46896L10.6345 5.83456C10.7083 5.75815 10.7965 5.69721 10.8942 5.65528C10.9918 5.61335 11.0967 5.59129 11.203 5.59036C11.3092 5.58944 11.4145 5.60968 11.5128 5.64991C11.6112 5.69013 11.7005 5.74953 11.7756 5.82465C11.8507 5.89976 11.9101 5.98908 11.9503 6.0874C11.9906 6.18572 12.0108 6.29106 12.0099 6.39728C12.009 6.50351 11.9869 6.60848 11.945 6.70609C11.903 6.80369 11.8421 6.89196 11.7657 6.96576L8.56567 10.1658C8.41565 10.3157 8.21221 10.4 8.00007 10.4C7.78794 10.4 7.5845 10.3157 7.43447 10.1658L4.23447 6.96576C4.0845 6.81574 4.00024 6.61229 4.00024 6.40016C4.00024 6.18803 4.0845 5.98458 4.23447 5.83456Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.1471d260df132fa24c9c8b47faa4a27f.svg";
export { ForwardRef as ReactComponent };